import { Route, Routes } from "react-router";
import OrganizationSidebar from "../my-organization/OrganizationSidebar";
import NotificationSettingsComponent from "./NotificationSettings/NotificationSettingsComponent";
import MyProfileComponent from "../platform-settings/MyProfile/MyProfileComponent";
import OrganizationUserPaymentAccountsPage from "./payment-accounts";
import "../platform-settings/PlatformSettingsStyles.css";

/**
 * "My Settings" area — a top-right-menu section available to every role (not permissioned).
 * Left rail: "My Profile" (moved here from the "Propertelligent"/Platform Settings area for org users),
 * "Payment Accounts" (organization users only — their own self-managed Plaid receiving account, used as a
 * payee on payables), and "Notification Settings" (per-user email opt-outs). The notification list itself is
 * role-filtered server-side, so the page simply renders whatever groups the API returns.
 */
export const MySettings = () => {
  return (
    <div className="PlatformSettingContentContainer d-flex">
      <OrganizationSidebar pageType="my-settings" />
      <div className="PlatformSettingRightSideContent">
        <Routes>
          <Route path="/notification-settings" element={<NotificationSettingsComponent />} />
          <Route path="/myprofile" element={<MyProfileComponent />} />
          <Route path="/payment-accounts" element={<OrganizationUserPaymentAccountsPage />} />
        </Routes>
      </div>
    </div>
  );
};
